import { Text } from '@village/ui';
import styled, { css } from 'styled-components';

const Container = styled.div<{ $borders: boolean }>`
    position: relative;
    ${({ theme, $borders }) =>
        $borders &&
        css`
            padding: 1.5rem 0;
            border-top: 1px solid ${theme.vui.colors.border.divider.default};
            border-bottom: 1px solid ${theme.vui.colors.border.divider.default};
        `}
`;

const Wrapper = styled.div`
    display: grid;
    row-gap: 1.5rem;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

const Title = styled(Text)`
    margin-bottom: 1.5rem;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const InfoGroup = styled.div`
    display: grid;
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

export { Container, Wrapper, Header, Title, InfoGroup };
